// Author Liang Gang Qiang
// Date 2021-10-15 09:54:24

class ImfMstShiftTeam {
constructor({
        id = null,
        mstShiftId = '',
        name = '',
        code = '',
        admDeptId = '',
        emAclDeptName = '',
        remark = ''}
= {}) {
    this.id = id;
    this.mstShiftId = mstShiftId;
    this.name = name;
    this.code = code;
    this.admDeptId = admDeptId;
    this.emAclDeptName = emAclDeptName;
    this.remark = remark;
}
}

function newEntity() {
return new ImfMstShiftTeam();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'id',
        label: 'label.em.admin.imfMstShiftTeam.grid.id',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'mstShiftId',
        label: 'label.em.admin.imfMstShiftTeam.grid.mstShiftId',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'mstShiftName',
        label: 'label.em.admin.imfMstShiftTeam.grid.mstShiftName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'name',
        label: 'label.em.admin.imfMstShiftTeam.grid.name',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'code',
        label: 'label.em.admin.imfMstShiftTeam.grid.code',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'admDeptId',
        label: 'label.em.admin.imfMstShiftTeam.grid.admDeptId',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'remark',
        label: 'label.em.admin.imfMstShiftTeam.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea'
        }
        },
        {
        key: 'emAclDeptName',
        label: 'label.em.admin.imfMstShiftTeam.grid.emAclDeptName',
        sortable: true,
        form: {
        type: 'input'
        }
        }
    ])}

const filter = {
    idFilter : "",
    idListFilter : "",
    mstShiftIdFilter : "",
    nameFilter : "",
    codeFilter : "",
    emAclDeptIdFilter : "",
    emAclDeptNameFilter : "",
    emAclDeptNodeCodeFilter : "",
    emAclDeptNodeCodeNameFilter : ""
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'mstShiftIdFilter',
        label: 'label.em.admin.imfMstShiftTeam.filter.mstShiftId',
        disabled: false,
        form: {
        type: 'entitySelect'
            ,entity: 'imfMstShift'
            ,showLabelSelectOne: true
                }
        },
        {
        key: 'nameFilter',
        label: 'label.em.admin.imfMstShiftTeam.filter.name',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'codeFilter',
        label: 'label.em.admin.imfMstShiftTeam.filter.code',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'emAclDeptNameFilter',
        label: 'label.em.admin.imfMstShiftTeam.filter.emAclDeptName',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'emAclDept'
            ,correspondingField: 'name'
            ,fieldsBindingByEntityModalSelected: '{"emAclDeptId":"id"}'
                }
        },
        {
        key: 'emAclDeptNodeCodeNameFilter',
        label: 'label.em.admin.imfMstShiftTeam.filter.emAclDeptNodeCodeName',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'emAclDept'
            ,correspondingField: 'name'
            ,fieldsBindingByEntityModalSelected: '{"emAclDeptNodeCode":"nodeCode"}'
                }
        }
];


    const entityFormConfigs = [
        {
        key: 'mstShiftId',
        label: 'label.em.admin.imfMstShiftTeam.entity.mstShiftId',
        sortable: true,
        disabled: false,
        form: {
        type: 'entitySelect'
            ,entity: 'imfMstShift'
            ,showLabelSelectOne: true
                }
        },
        {
        key: 'name',
        label: 'label.em.admin.imfMstShiftTeam.entity.name',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
            ,required: true
                }
        },
        {
        key: 'code',
        label: 'label.em.admin.imfMstShiftTeam.entity.code',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'emAclDeptName',
        label: 'label.em.admin.imfMstShiftTeam.entity.emAclDeptName',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'emAclDept'
            ,correspondingField: 'name'
            ,fieldsBindingByEntityModalSelected: '{"admDeptId":"id"}'
                }
        },
        {
        key: 'remark',
        label: 'label.em.admin.imfMstShiftTeam.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea'
                }
        }
]

export {ImfMstShiftTeam, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
